module.exports = __webpack_public_path__ + "static/colouring_in_bed-083b0ed12baa2a780987ac8eb96efc6e.pdf";